/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiTwitter, FiLinkedin } from 'react-icons/fi';
import { MdKeyboardArrowUp } from 'react-icons/md';
import './AppFooter.scss';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import {
  isNullOrEmpty,
  isMobileWidth,
  scrollToTop,
} from '../../helper-utils/appUtils';
import { getStringFromLS } from '../../helper-utils/localStorage';
import {
  APP_LOGO_URL,
  APP_AGENT_LOGO_URL,
} from '../../../saas/AppStorageStaticNames';
import { NAVIGATION_ROUTES } from '../../constants/Constants';
import AppIconButton from '../app-icon-button/AppIconButton';

function AppFooter() {
  const { appConfig } = useAppContext();
  const location = useLocation();
  const [imageLoadError, setImageLoadError] = useState(false);
  const [hasNoImage, setHasNoImage] = useState(false);

  // Tabler Icons CDN loader
  useEffect(() => {
    const linkId = 'tabler-icons-cdn';
    if (!document.getElementById(linkId)) {
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href =
        'https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@3.3.0/tabler-icons.min.css';
      document.head.appendChild(link);
    }
  }, []);

  const shouldHideFooter =
    appConfig?.hideFooterinsearch && location.pathname !== '/login';
  const hasPageScrollToTopButton =
    location.pathname ===
      NAVIGATION_ROUTES.FLIGHT.ONE_WAY_FLIGHT_RESULTS_ROUTE ||
    location.pathname ===
      NAVIGATION_ROUTES.FLIGHT.ROUND_TRIP_FLIGHT_RESULTS_ROUTE ||
    location.pathname ===
      NAVIGATION_ROUTES.FLIGHT.INTERNATIONAL_ROUND_TRIP_FLIGHT_RESULTS_ROUTE;
  const onlineVisaFooterClass =
    location.pathname === '/online-visa/options'
      ? ' site-footer--visa-options'
      : location.pathname === '/online-visa/booking'
      ? ' site-footer--visa-booking'
      : '';

  if (shouldHideFooter) return null;

  return (
    <footer
      className={`site-footer position-relative app-footer${onlineVisaFooterClass}`}
    >
      {!isMobileWidth() && !hasPageScrollToTopButton && (
        <AppIconButton
          className="rounded-scroll-tp-top-btn"
          variant="outlined"
          onClick={scrollToTop}
        >
          <MdKeyboardArrowUp />
        </AppIconButton>
      )}
      <div className="container">
        <div className="footer-grid">
          <div>
            <NavLink to="/" className="cursor-pointer app-header-logo">
              {!imageLoadError &&
              !isNullOrEmpty(getStringFromLS(APP_AGENT_LOGO_URL)) ? (
                <img
                  src={getStringFromLS(APP_AGENT_LOGO_URL)}
                  alt=""
                  style={{ maxHeight: `${appConfig?.logoHeight || 40}px` }}
                  onError={(e) => {
                    e.target.src = null;
                    e.currentTarget.onerror = null;
                    setImageLoadError(true);
                  }}
                />
              ) : !hasNoImage ? (
                <img
                  src={getStringFromLS(APP_LOGO_URL)}
                  alt=""
                  style={{ maxHeight: `${appConfig?.logoHeight || 40}px` }}
                  onError={(e) => {
                    e.target.src = null;
                    e.currentTarget.onerror = null;
                    setHasNoImage(true);
                  }}
                />
              ) : (
                ''
              )}
            </NavLink>
            <p className="footer-desc">
              Fastays is a leading B2B travel portal that empowers travel agents
              with seamless booking solutions for flights, hotels, buses, and
              other travel services, helping them grow their business with
              advanced technology and reliable support.
            </p>
            <div className="footer-social">
              <a
                href={
                  appConfig?.facebookUrl ||
                  'https://www.facebook.com/fastaysofficial/'
                }
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FiFacebook />
              </a>
              <a
                href={
                  appConfig?.instagramUrl ||
                  'https://www.instagram.com/fastays/'
                }
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FiInstagram />
              </a>
              <a
                href={appConfig?.twitterUrl || 'https://x.com/fastays'}
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter"
              >
                <FiTwitter />
              </a>
              <a
                href={
                  appConfig?.linkedinUrl ||
                  'https://in.linkedin.com/company/fastays-com'
                }
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FiLinkedin />
              </a>
            </div>
          </div>

          <div>
            <div className="footer-heading">Important Links</div>
            <ul className="footer-links">
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms-conditions">Terms and Conditions</a>
              </li>
              <li>
                <a href="/about-us">About Us</a>
              </li>
            </ul>
          </div>

          <div>
            <div className="footer-heading">Get in Touch</div>
            <a
              href="tel:+919187696392"
              className="footer-contact-item text-decoration-none"
            >
              <i className="ti ti-phone" aria-hidden="true" /> +91 91876 96392
            </a>
            <a
              href="mailto:info@fastays.com"
              className="footer-contact-item text-decoration-none"
            >
              <i className="ti ti-mail" aria-hidden="true" /> info@fastays.com
            </a>
            <div className="footer-contact-item">
              <i className="ti ti-world" aria-hidden="true" />{' '}
              https://agents.fastays.com
            </div>
            <div className="footer-contact-item">
              <i className="ti ti-map-pin" aria-hidden="true" /> 1112, 11th
              Floor, Barton Centre, MG Road, Bangalore, KA 560001
            </div>
          </div>
        </div>
        <div className="footer-copyright d-flex justify-content-between align-items-center">
          <span>© 2026 Fastays</span>
          <span>All rights reserved</span>
        </div>
      </div>
    </footer>
  );
}

export default AppFooter;
